import { ArrowUpRight } from "lucide-react";

// "More from Damani Holdings" (Aziz, Oct 15) — copy verbatim from the owner; four companies only, no placeholders. Norcross address on every company.
const ADDRESS = "5675 Jimmy Carter Blvd, Suite 725, Norcross, GA 30071";
const LUCKY_PHONE = "(325) 221-4234";
const LUCKY_TEL = "+13252214234";

export const DAMANI_COMPANIES = [
  {
    id: "holo-answers", name: "Holo Answers", accent: "cyan",
    tagline: "An AI phone answering service that picks up every call so you never miss a customer.",
    bullets: [
      "Answers every call 24/7, handles FAQs, and takes orders and bookings",
      "Transfers hot callers to your team",
      "Plans: Answer $199/mo (500 min, $99 setup) · Order $349/mo (800 min, $299 setup) · Pro $599/mo (1,500 min, $499 setup). 14-day trial on every plan. Refer a business and get one month free as account credit.",
    ],
    cta: "Start your 14-day trial", href: "https://callholo.com",
  },
  {
    id: "phone-play", name: "Phone Play", accent: "magenta",
    tagline: "A browser-based mobile game app with free skill games, daily challenges and duels.",
    bullets: [
      "Daily WordVolt and Solitaire challenges, plus quick skill games (Speed Math, Reaction Rush, Memory Matrix)",
      "1v1 duels and tournaments against real players, and a Fun Coin arcade (Fun Coins are for entertainment only and have no monetary value)",
      "Free to join for players 18+ with an email address",
    ],
    cta: "Play free", href: "https://phoneplay.net",
  },
  { id: "jio-force", name: "Jio Force", accent: "yellow", tagline: "Your entire sales floor in one login.", bullets: [], cta: "Learn more", href: "https://jioforce.com" },
  { id: "servicepilot", name: "ServicePilot", accent: "lime", tagline: "The right pro, right now.", bullets: [], cta: "Book a pro", href: "https://servicepilot.solutions" },
];

const ACCENT = {
  cyan: { text: "text-neon-cyan", border: "border-neon-cyan/50", bg: "bg-neon-cyan" },
  magenta: { text: "text-neon-magenta", border: "border-neon-magenta/50", bg: "bg-neon-magenta" },
  yellow: { text: "text-neon-yellow", border: "border-neon-yellow/50", bg: "bg-neon-yellow" },
  lime: { text: "text-lime-300", border: "border-lime-300/50", bg: "bg-lime-300" },
};

function CompanyCard({ c, index }) {
  const a = ACCENT[c.accent];
  return (
    <article className={`relative border ${a.border} bg-black/40 p-5 sm:p-6 flex flex-col rise`} style={{ animationDelay: `${index * 90}ms` }} data-testid={`damani-card-${c.id}`}>
      <div className={`font-mono text-[10px] uppercase tracking-[0.28em] ${a.text}`}>0{index + 1}</div>
      <h3 className="mt-2 font-heading font-black text-xl text-white" data-testid={`damani-card-${c.id}-name`}>{c.name}</h3>
      <p className="mt-2 text-sm text-white/75 leading-relaxed" data-testid={`damani-card-${c.id}-tagline`}>{c.tagline}</p>
      {c.bullets.length > 0 && (
        <ul className="mt-4 space-y-2" data-testid={`damani-card-${c.id}-bullets`}>
          {c.bullets.map((b) => (
            <li key={b} className="flex gap-2.5 text-sm text-white/65 leading-relaxed"><span className={`mt-[7px] w-1.5 h-1.5 shrink-0 ${a.bg}`} />{b}</li>
          ))}
        </ul>
      )}
      <div className="mt-auto pt-5">
        <a href={c.href} target="_blank" rel="noopener noreferrer" data-testid={`damani-card-${c.id}-cta`}
           className={`inline-flex items-center gap-2 h-11 px-5 ${a.bg} text-black hover:bg-white transition-colors font-heading font-bold text-sm uppercase tracking-wide`}>
          {c.cta} <ArrowUpRight className="w-4 h-4" />
        </a>
        <div className="mt-3 font-mono text-[10px] text-white/45 leading-relaxed">{c.name} · {ADDRESS}</div>
      </div>
    </article>
  );
}

export default function DamaniHoldingsSection() {
  return (
    <section id="damani-holdings" className="border-t border-border/60 bg-card/20 scroll-mt-20" data-testid="damani-holdings-section">
      <div className="max-w-7xl mx-auto px-4 py-14 sm:py-16">
        <div className="font-mono text-[10px] uppercase tracking-[0.28em] text-neon-cyan">Damani Holdings</div>
        <h2 className="mt-2 font-heading font-black text-base md:text-lg text-white" data-testid="damani-holdings-title">More from Damani Holdings</h2>
        <p className="mt-3 text-sm sm:text-base text-white/70 leading-relaxed max-w-3xl" data-testid="damani-holdings-intro">
          ArcadeOps is part of Damani Holdings. Our other companies help route operators, venues and B2B partners such as vape distributors and card processors answer every call, sell more and run day-to-day work.
        </p>
        <div className="mt-8 grid gap-4 md:grid-cols-2">
          {DAMANI_COMPANIES.map((c, i) => <CompanyCard key={c.id} c={c} index={i} />)}
        </div>
        <div className="mt-8 border border-border/70 bg-black/30 p-5 text-sm text-white/70 leading-relaxed" data-testid="damani-holdings-footer">
          <p>
            Questions about any Damani Holdings service? Email <a href="mailto:sales@arcadeops.net" className="text-neon-cyan hover:text-white underline-offset-4 hover:underline" data-testid="damani-holdings-email">sales@arcadeops.net</a>, or call or text Lucky at <a href={`tel:${LUCKY_TEL}`} className="text-neon-yellow hover:text-white underline-offset-4 hover:underline" data-testid="damani-holdings-call">{LUCKY_PHONE}</a>.
          </p>
          <p className="mt-2 font-mono text-[11px] text-white/50" data-testid="damani-holdings-address">Damani Holdings · {ADDRESS}</p>
        </div>
      </div>
    </section>
  );
}
